import { AcctPermission } from 'generated/graphql'

export const dropdownOption = [
  {
    path: `/digital-reports/access-security`,
    defaultPath: `/digital-reports/access-security`,
    title: `Access Security`,
    label: `Access Security Reports`,
    permission: AcctPermission.AccessSecurityDigitalReportView,
    disabled: false,
    package_name: 'ACCESS_SECURITY',
  },
  {
    path: `/digital-reports/general-ledger`,
    defaultPath: `/digital-reports/general-ledger`,
    title: `General Ledger`,
    label: `General Ledger Reports`,
    permission: AcctPermission.GeneralLedgerDigitalReportsView,
    disabled: false,
    package_name: 'GENERAL_LEDGER',
  },
  {
    path: `/digital-reports/cash-book`,
    defaultPath: `/digital-reports/cash-book`,
    title: `Cash Book`,
    label: `Cash Book Reports`,
    permission: AcctPermission.CashBookDigitalReportView,
    disabled: false,
    isDefault: false,
    deployed: true,
    package_name: 'CASH_BOOK',
  },
  {
    path: `/digital-reports/account-receivable`,
    defaultPath: `/digital-reports/account-receivable`,
    title: `Account Receivable`,
    label: `Account Receivable Reports`,
    permission: AcctPermission.AccReceivableDigitalReportsView,
    deployed: true,
    disabled: false,
    package_name: 'ACCOUNT_RECEIVABLE',
  },
  {
    path: `/digital-reports/account-payable`,
    defaultPath: `/digital-reports/account-payable`,
    title: `Account Payable`,
    label: `Account Payable Reports`,
    permission: AcctPermission.AccPayableDigitalReportView,
    deployed: true,
    disabled: false,
    package_name: 'ACCOUNT_PAYABLE',
  },
  {
    path: `/digital-reports/inventory-control`,
    defaultPath: `/digital-reports/inventory-control`,
    title: `Inventory Control`,
    label: `Inventory Control Reports`,
    permission: AcctPermission.InventoryControlDigitalReportsView,
    disabled: false,
    isDefault: false,
    deployed: true,
    package_name: 'INVENTORY_CONTROL',
  },
  {
    path: `/digital-reports/general-purchase`,
    defaultPath: `/digital-reports/general-purchase`,
    title: `General Purchase`,
    label: `General Purchase Reports`,
    deployed: process.env.REACT_APP_LOCAL_DB === 'prod' ? false : true,
    disabled: false,
    permission: AcctPermission.GeneralPurchaseDigitalReportsView,
    package_name: 'GENERAL_PURCHASES',
  },
  {
    path: `/digital-reports/fixed-assets`,
    defaultPath: `/digital-reports/fixed-assets`,
    title: `Fixed Assets`,
    label: `Fixed Assets Reports`,
    deployed:
      process.env.REACT_APP_LOCAL_DB === 'local' ||
      process.env.REACT_APP_LOCAL_DB === 'azure' ||
      process.env.REACT_APP_LOCAL_DB === 'ent-uat' ||
      process.env.REACT_APP_LOCAL_DB === 'prod-ent' ||
      process.env.REACT_APP_LOCAL_DB === 'prod-ent2' ||
      process.env.REACT_APP_LOCAL_DB === 'prod-ax-px' ||
      process.env.REACT_APP_LOCAL_DB === 'axifcadev' ||
      process.env.REACT_APP_LOCAL_DB === 'internal' ||
      process.env.REACT_APP_LOCAL_DB === 'ent-train' ||
      process.env.REACT_APP_LOCAL_DB === 'staging'
        ? true
        : false,
    disabled: false,
    permission: true,
    package_name: 'FIXED_ASSET',
  },
]
